export const colors = Object.freeze({
  color1: '#fc842d',
  color2: '#9b9faa',
  color3: '#e0e0e0',
  color4: '#212121',
  color5: '#264061',
});
